import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class BoletoService {
  constructor(
    private http: HttpClient
  ) { }

  obterBoletos(contaId, params) {
    return this.http
      .get(urls.odata + '/Boletos', {
        params: {
          ...params,
          $count: true,
          contaId,
        }
      });
  }
}
